// extracted by mini-css-extract-plugin
export default {"check_message":"CheckMessage_check_message__VG6M4","bounce-in":"CheckMessage_bounce-in__74EIr"};